import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "materialize-css";
import "materialize-css/dist/css/materialize.min.css";
import "materialize-css/dist/js/materialize.min.js";
import "material-design-icons/iconfont/material-icons.css";
import moment from "moment";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

String.prototype.startsWith ||
  (String.prototype.startsWith = function(word) {
    return this.lastIndexOf(word, 0) === 0;
  });
String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.isValidateEmail = function() {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    this
  );
};

String.prototype.endsWith ||
  (String.prototype.endsWith = function(word) {
    return this.indexOf(word, this.length - word.length) !== -1;
  });

String.prototype.isNumber = function() {
  return /^[0-9]+$/.test(this);
};

Date.prototype.addHours = function(h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};
Date.prototype.addDays = function(d) {
  this.setTime(this.getTime() + d * 24 * 60 * 60 * 1000);
  return this;
};

Date.daysBetween = function(date1, date2) {
  //Get 1 day in milliseconds
  //var one_day=1000*60*60*24;

  // Convert both dates to milliseconds
  var date1_ms = date1.getTime();
  var date2_ms = date2.getTime();

  // Calculate the difference in milliseconds
  var difference_ms = date2_ms - date1_ms;
  //take out milliseconds
  difference_ms = difference_ms / 1000;
  var seconds = Math.floor(difference_ms % 60);
  difference_ms = difference_ms / 60;
  var minutes = Math.floor(difference_ms % 60);
  difference_ms = difference_ms / 60;
  var hours = Math.floor(difference_ms % 24);
  var days = Math.floor(difference_ms / 24);

  return (
    days +
    " days, " +
    hours +
    " hours, " +
    minutes +
    " minutes, and " +
    seconds +
    " seconds"
  );
};

export const bus = new Vue();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
